import Vue from 'vue';
import VueRouter from 'vue-router';

// import mapActions from 'vuex';
import store from '../store';

import auth from '../middleware/auth';
import admin from '../middleware/admin';

// import Home from '../views/Home.vue';
import LandingPage from '../views/LandingPage.vue';
import Account from '../views/Account.vue';
import Invitations from '../views/Invitations.vue';
import Authentication from '../views/Authentication.vue';
import Guide from '../views/Guide.vue';

// Liens autres
import CGU from '../views/CGU.vue';
import Policy from '../views/Policy.vue';
import PasswordReset from '../views/PasswordReset.vue';

// Snippets
import Snippets from '../views/Snippets.vue';
import AllSnippets from '../views/snippets/Dashboard.vue';
import CreateSnippet from '../views/snippets/Create.vue';
import EditSnippet from '../views/snippets/Edit.vue';
import SnippetSettings from '../views/snippets/Settings.vue';
import ProjectsArchive from '../views/snippets/Archive.vue';

//Project and groups
import ProjectShowGroupes from '../views/snippets/projects/ProjectShowGroupes'
import ProjectShow from '../views/snippets/projects/ProjectShow'
/** Admin */
import Admin from '../views/Admin.vue';
import Dashboard from '../views/admin/Dashboard.vue';
/** Admin Users */
import adminUsers from '../views/admin/Users.vue';
import adminUser from '../views/admin/users/User.vue';
import adminUserDetails from '../views/admin/users/UserDetails.vue';

/** Admin Projects */
import adminProjects from '../views/admin/Projects.vue';
import adminProject from '../views/admin/projects/Project.vue';
import adminProjectDetails from '../views/admin/projects/ProjectDetails.vue';
import adminProjectTeam from '../views/admin/projects/ProjectTeam.vue';
import adminProjectContent from '../views/admin/projects/ProjectContent.vue';

/** Admin Snippets */
import adminSnippets from '../views/admin/Snippets.vue';
import adminSnippet from '../views/admin/snippets/Snippet.vue';
import adminSnippetDetails from '../views/admin/snippets/SnippetDetails.vue';

/* Error Pages */
import ErrorPage from '../views/Error.vue';
import Error401 from '../views/error/401.vue';
import Error403 from '../views/error/403.vue';
import Error404 from '../views/error/404.vue';

Vue.use(VueRouter);

const routes = [{
    path: '/',
    name: 'Accueil',
    component: LandingPage,
    meta: {
      requiresAuth: false,
      alternativeLink: '/projects',
    },
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: AllSnippets,
    meta: {
      middleware: auth,
      requiresAuth: true,
      sidebar: true
    },
  },
  {
    path: '/guide',
    name: 'Guide',
    component: Guide,
    meta: {
      requiresAuth: false,
    },
  },
  {
    path: '/conditions-utilisation',
    name: 'CGU',
    component: CGU,
    meta: {
      requiresAuth: false,
    },
  },
  {
    path: '/politique-confidentialite',
    name: 'Policy',
    component: Policy,
    meta: {
      requiresAuth: false,
    },
  },
  {
    path: '/authentification',
    name: 'Authentication',
    component: Authentication,
    meta: {
      requiresAuth: false,
    },
  },
  {
    path: '/mot-de-passe-oublie',
    name: 'PasswordReset',
    component: PasswordReset,
    meta: {
      requiresAuth: false,
    },
  },
  {
    path: '/projects',
    name: 'Project',
    component: Snippets,
    meta: {
      middleware: auth,
      requiresAuth: true,
      sidebar: true
    },
    children: [{
        path: 'create',
        name: 'Create Project',
        component: CreateSnippet,
        meta: {
          middleware: auth,
          requiresAuth: true,
          sidebar: true
        },
      },
      /*{
        path: ':idProject([0-9]+)',
        component: ProjectShow,
        name: 'members',
        meta: {
          middleware: auth,
          requiresAuth: true,
          sidebar: true
        },
      },*/
      {
        path: ':idProject([0-9]+)/groups',
        component: ProjectShowGroupes,
        name: 'members',
        meta: {
          middleware: auth,
          requiresAuth: true,
          sidebar: true
        },
      },
      {
        path: ':idProject([0-9]+)/groups/:idGroup',
        name: 'Edit Project',
        component: EditSnippet,
        meta: {
          middleware: [auth],
          sidebar: true
        },
      },
      {
        path: ':idProject/settings',
        name: 'Manage Project',
        component: SnippetSettings,
        meta: {
          middleware: [auth],
          sidebar: true
        },
      },
      {
        path: 'archive',
        name: 'Projects Archive',
        component: ProjectsArchive,
        meta: {
          middleware: [auth],
          sidebar: true
        },
      },
    ],
  },
  {
    path: '/mon-compte',
    name: 'Account',
    component: Account,
    meta: {
      middleware: auth,
      requiresAuth: true,
      sidebar: true
    },
  },
  {
    path: '/mes-invitations',
    name: 'Invitations',
    component: Invitations,
    meta: {
      middleware: auth,
      sidebar: true
    },
  },
  {
    path: '/admin',
    redirect: '/admin/dashboard',
    name: 'admin',
    component: Admin,
    children: [{
        path: 'dashboard',
        name: 'Admin Dashboard',
        component: Dashboard,
        meta: {
          middleware: [auth, admin],
          sidebar: true
        },
      },
      {
        path: 'users',
        name: 'Admin Users',
        component: adminUsers,
        meta: {
          middleware: [auth, admin],
          sidebar: true
        },
      },
      {
        path: 'users/:idUser',
        component: adminUser,
        children: [
          {
            path: '',
            name: 'Admin User Details',
            component: adminUserDetails,
            meta: {
              middleware: [auth, admin],
            },
          },
        ],
        meta: {
          middleware: [auth, admin],
          sidebar: true
        },
      },
      {
        path: 'projects',
        name: 'Admin Projects',
        component: adminProjects,
        meta: {
          middleware: [auth, admin],
          sidebar: true
        },
      },
      {
        path: 'projects/:projectId',
        component: adminProject,
        children: [
          {
            path: '',
            name: 'Admin Project Details',
            component: adminProjectDetails,
            meta: {
              middleware: [auth, admin],
            },
          },
          {
            path: 'team',
            name: 'Admin Project Team',
            component: adminProjectTeam,
            meta: {
              middleware: [auth, admin],
            },
          },
          {
            path: 'content',
            name: 'Admin Project Content',
            component: adminProjectContent,
            meta: {
              middleware: [auth, admin],
            },
          },
        ],
        meta: {
          middleware: [auth, admin],
          sidebar: true
        },
      },
    ],
  },
  {
    path: '/erreur',
    component: ErrorPage,
    children: [{
        path: '401',
        name: '401 Non autorisé',
        component: Error401,
      },
      {
        path: '403',
        name: '403 Accès refusé',
        component: Error403,
      },
      {
        path: '404',
        name: '404 Page non trouvée',
        component: Error404,
      },
    ],
  },
  {
    path: '*',
    component: ErrorPage,
    children: [
      {
        path: '',
        name: 'Page non trouvée',
        component: Error404,
      },
    ],
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

function nextFactory(context, middleware, index) {
    const subsequentMiddleware = middleware[index];

    if (!subsequentMiddleware) return context.next;

    return (...parameters) => {

      context.next(...parameters);

      const nextMiddleware = nextFactory(context, middleware, index + 1);
      subsequentMiddleware({ ...context, next: nextMiddleware });
    };
  }

  router.beforeEach((to, from, next) => {
    if (to.meta.middleware) {
      const middleware = Array.isArray(to.meta.middleware)
        ? to.meta.middleware
        : [to.meta.middleware];

      const context = {
        from,
        next,
        router,
        to,
      };
      const nextMiddleware = nextFactory(context, middleware, 1);

      return middleware[0]({ ...context, next: nextMiddleware });
    }

    return next();
  });

export default router;
